import { useState , useEffect } from 'react'
import listviewActive from 'assets/img/listview_active.svg';
import listviewInactive from 'assets/img/listview_inactive.svg';
import gridviewActive from 'assets/img/gridview_active.svg';
import gridviewInactive from 'assets/img/gridview_inactive.svg';
import styles from './styles.module.sass'

const ViewsFilter = (props) => {
    const {
        setActiveView
    } = props

    const [listView, setListView] = useState(listviewInactive)
    const [gridView, setGridView] = useState(gridviewActive)
    const [viewActive, setViewActive] = useState('mosaico')
    const changeView = (typeView) => {
        if(typeView === 'mosaico'){
            setListView(listviewInactive)
            setGridView(gridviewActive)
            setViewActive(typeView)
        }else{
            setListView(listviewActive)
            setGridView(gridviewInactive)
            setViewActive(typeView)
        }
    }

    useEffect(()=>{
        if(viewActive){
            setActiveView(viewActive)
        }
    },[viewActive])


    return(
        <div className={styles?.viewpicker}>
            <span>Vistas</span>
            <div className={styles?.contViewType}>
                <div onClick={() => changeView('lista')} aria-hidden="true">
                    <img src={listView} alt="Lista" />
                </div>
                <div onClick={() => changeView('mosaico')} aria-hidden="true">
                    <img src={gridView} alt="Mosaico" />
                </div>
            </div>
        </div>
    )
}

export default ViewsFilter